/* unplugin-vue-components disabled */import script from "./VoucherCodeVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherCodeVerify.vue?vue&type=script&setup=true&lang=js"

import "./VoucherCodeVerify.vue?vue&type=style&index=0&id=48aa7525&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48aa7525"]])

export default __exports__